export default 
{
    App:{
        BackHome:"Retour à la page d'accueil",
        Logout:"Se déconnecter",
        ShowLeftDrawerTooltip:"Afficher le panneau de gauche",
        HideLeftDrawerTooltip:"Masquer le panneau de gauche",
        ShowRightDrawerTooltip:"Afficher le panneau de droite",
        HideRightDrawerTooltip:"Masquer le panneau de droite",
        Close:"Fermer",
        MailSkin:"Skin de mail",
        MailTemplate:"Template de mail",
        ForfaitAddCart:"Un forfait '{forfait}' a bien été ajouté au panier pour un montant total de {prix} | {n} forfaits '{forfait}' ont bien été ajoutés au panier pour un montant total de {prix}",   
    },    
    Form:{
        Required:"Champs obligatoire",
        MinChar:"Au moins {count} caractère | Au moins {count} caractères",
        PasswordMismatch:"Les mots de passes ne correspondent pas!",
        EmailInvalid: "Entrez un email valide"
    },
    LangSwitcher:{
        Tooltip:"Langue"
    },    
    Login: {
        Login: "Identification",
        Email: "Email",
        Password: "Mot de passe",
        LoginAction: "S'identifier",
        SendRequest:"Envoyer la demande",
        CancelRequest:"Retour à l'identification",
        AuthenticationProgress: "Identification en cours",
        AuthenticationSuccess: "Identification réussie",
        AuthenticationError: "Erreur d'identification",
        PassForgottenSuccess:"Demande envoyée avec succès",
        PassForgottenProgress:"Demande en cours",
        PassForgottenError:"Erreur : Le compte et le mail ne correspondent pas",
        ForgotPassword:"Mot de passe oublié",        
        CreateAccess:"Creer un accès",
        InfosAccount:"Votre compte n'est pas encore activé",
        EnterStayDate:"Renseigner vos date de séjour",
        Name:"Nom"
    },
    Home: {
        Profil:"Gérer votre compte",
        FindSwimmSchool:"Trouver vos cours",
        Tickets:"Boutique en ligne",
        Administration:"Administration"
    },
    Profil: {
        ProfilTitle:"VOTRE COMPTE",
        YourProfil:"Votre profil",
        Password:"Mot de passe",
        MyBooking:"Mes reservations",
        SessionHistory:"Historique des cours",
        Command:"Mes achats"
    },
    Address:{
        IndoorInfos:"Bâtiment - Immeuble - Résidence",
        NumberWay:"Numéro de voie",
        OutsideInfos:"Nom voie",
        PostBox:"BP - Lieu dit",
        PostalCode:"Code postal",
        City:"Ville"

    },
    Cart:{                
        SeeCart:"Voir le panier",
        YourCart:"VOTRE PANIER",
        Continue:"Continuer",
        UnitPrice:"Prix unitaire",
        Quantity:"Quantité",
        TotalTTC: "Total TTC",
        PartTVA: "Dont TVA",
        Add:"Ajouter",
        Remove:"Retirer",
        ClientName:"Nom client",
        FinalizeOrder:"Afin de finaliser la commande",
        InOrderToValidate:"Afin de valider votre commande identifiez vous ou créez un accès",
        AlertRemoveItem:"Souhaitez-vous retirer complètement ce produit de votre panier ?",
        Clear:"Vider le panier",
        AlertClear:"Souhaitez-vous complètement vider votre panier?",
        AlertOrderSavedTitle:"Merci !",
        AlertOrderSaved:"Votre commande à bien été enregistrée"
    },
    Person:{
        Name:"Nom",
        Tickets:"{count} entrée | {count} entrées"
    },
    Global:{
        Yes:"oui",
        No:"non",
        Warning:"Attention",
        Ok:"Ok",
        Validate:"Valider",
        Delete:"Supprimer",
        Cancel:"Annuler",
        Save:"Sauvegarder",
        Close:"Fermer", 
        Choose:"Choisir",
        Language:"Langue",
        Edit:"Modifier",
        With:"Avec",
        Without:"Sans",
        WeAre:"Nous sommes le",
        Welcome:"Bienvenue",
        Between:"entre",
        And:"et",
        Full:"Complet",
        Loaded:"Chargé",
        UpdateDeliverySlots:"Mise à jour des crenaux",
        Today:"Aujourd'hui",
        Tomorrow:"Demain",
        Yesterday:"Hier",
        FormatPeriode:"du {start} au {end}",
        download:"Télécharger",
        Days:"j",
        Back:"Retour",
        ConfirmDelete:"Confirmer la suppression",
        Reset:"Reinitialiser"
    },
}
